import {axiosInstance} from './axios';

export async function getNewsApi() {
  try {
    return await axiosInstance.get("/api/v1/news")
  }catch (e) {
    console.log(e)
    return null;
  }
}

export async function addNewsApi(data) {
  try {
    return await axiosInstance.post("/api/v1/news",data)
  }catch (e) {
    return null;
  }
}


export async function getNewsByID(id) {
  try {
    return await axiosInstance.get(`/api/v1/news/${id}`)
  }catch (e) {
    return null;
  }
}
export async function editNews(data,id) {
  try {
    return await axiosInstance.put(`/api/v1/news/${id}`,data)
  }catch (e) {
    return null;
  }
}

export async function removeNews(id) {
  try {
    return await axiosInstance.delete(`/api/v1/news/${id}`)
  }catch (e) {
    return null;
  }
}
